export default "__VITE_ASSET__DOVZ$qLX__"